import { logout } from '@loadedhub/timeclock-management'
import logger from './logger'
import appConfig from './appConfig'

const LOGOUT_REQUESTED = '@@loaded/logout-requested'
const LOGOUT_COMPLETED = '@@loaded/logout-completed'

window.addEventListener(LOGOUT_REQUESTED, () => {
  logger.info('Processing logout in the React app')

  const timeclockV2ApiBaseUrl = appConfig.get<string>('timeclockV2ApiUrl')
  if (timeclockV2ApiBaseUrl) {
    // note while this is an async call, it is not awaited because we don't want
    // to block the logout process and we want to continue with the logout
    // process even if the logout fails, internally this call will continue
    // the network request even on page navigation
    logout(timeclockV2ApiBaseUrl)
  }

  logger.info('Logout completed in the React app')
  window.dispatchEvent(new CustomEvent(LOGOUT_COMPLETED))
})
